import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { SolicitudActividadesService } from '../../../../services/database/pqrsd/solicitud-actividades.service';
import { IGetActividadSolicitudInfo, SeguimientoDTO } from '../../../../shared/interfaces/database/pqrsd';
import { firstValueFrom, forkJoin } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ButtonModule } from 'primeng/button';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { AccessRole, DEFAULT_DATE_FORMAT, FormGroupErrorMessageComponent, LoadingPanelService, LocalService, noWhitespaceValidator, Utils, VisorComponent } from 'lib-base';
import { AdjuntosService } from '../../../../services/database/pqrsd/adjuntos.service';
import saveAs from 'file-saver';
import { SeguimientosService } from '../../../../services/database/pqrsd/seguimientos.service';
import { Router } from '@angular/router';
import { IGetUsuariosValidos } from '../../../../shared/interfaces/database/tramite';
import { DropdownChangeEvent, DropdownModule } from 'primeng/dropdown';
import { SolicitudService } from '../../../../services/database/pqrsd/solicitud.service';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-seguimiento',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule, FormsModule,
    InputTextareaModule, TooltipModule,
    ButtonModule, DropdownModule,
    FileUploadModule, DialogModule,
    ConfirmDialogModule,
    FormGroupErrorMessageComponent, VisorComponent
  ],
  providers: [ConfirmationService],
  templateUrl: './seguimiento.component.html',
  styleUrl: './seguimiento.component.scss'
})
export class SeguimientoComponent implements OnInit {

  @Input() actividadId !: number;
  @Input() solicitudId !: number;
  solicitudInfo!: IGetActividadSolicitudInfo;

  trans: any = {};
  seguimientoForm!: FormGroup;
  readonly uploadFileSize: number = 1024 * 1024
  readonly defaultDateFormat = DEFAULT_DATE_FORMAT;
  role = AccessRole;

  usuariosValidos: IGetUsuariosValidos[] = [];
  selectedUsuarioIdValido !: number;

  displayRechazarModal = false;
  rechazarForm !: FormGroup;
  @ViewChild(VisorComponent) visorDialog !: VisorComponent;
  @ViewChild('fileUpload') fileUpload!: FileUpload;

  constructor(
    private readonly _sa: SolicitudActividadesService,
    private readonly _t: TranslateService, private readonly _fb: FormBuilder, private readonly _ms: MessageService,
    private readonly _cs: ConfirmationService, private readonly _lps: LoadingPanelService, public ls: LocalService, private readonly _s: SolicitudService,
    private readonly _as: AdjuntosService, private readonly _ss: SeguimientosService, private readonly _router: Router,
  ) {
    this.configureForm();
    this.configureRechazarForm();
  }

  ngOnInit(): void {
    this.translate();
    this.getActividadInfo();
    this.getUsuariosValidosParaActividad();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      radicado: this._t.get('common.radicado'),
      exito: this._t.get('common.exito'),
      seguimientoGuardado: this._t.get('msg.seguimientoGuardado'),
      actividadFinalizada: this._t.get('msg.actividadFinalizada'),
      confirmarFinalizacion: this._t.get('msg.confirmarFinalizacion'),
      orden: this._t.get('common.orden'),
      fechaInicioPlanificada: this._t.get('msg.fechaFinalizacionReal'),
      fechaCierrePlanificada: this._t.get('msg.fechaCierrePlanificada'),
      fechaInicioReal: this._t.get('msg.fechaInicioReal'),
      fechaFinalizacionReal: this._t.get('msg.fechaFinalizacionReal'),
      estadoDeLaActividad: this._t.get('msg.estadoDeLaActividad'),
      descripcionActividad: this._t.get('msg.descripcionActividad'),
      usuarioAsignado: this._t.get('common.usuarioAsignado'),
      rechazarTramite: this._t.get('common.rechazarTramite'),
      limpiar: this._t.get('form.button.limpiar'),
      guardar: this._t.get('form.button.guardar'),
      observaciones: this._t.get('common.observaciones'),
      reabrirActividad: this._t.get('common.reabrirActividad'),
      agregarDocumento: this._t.get('msg.agregarDocumento'),
      documento: this._t.get('common.documento'),
      seguimiento: this._t.get('common.seguimiento'),
      medioRecepcion: this._t.get('msg.medioRecepcion'),
      descripcionMedioRecepcion: this._t.get('msg.descripcionMedioRecepcion'),
      descripcion: this._t.get('common.descripcion'),
      tema: this._t.get('common.tema'),
      tipoDeTramite: this._t.get('common.tipoDeTrámite'),
      dependencia: this._t.get('common.dependencia'),
      tipo: this._t.get('common.tipo'),
      advertenciaCompletarCampos: this._t.get('msg.advertenciaCompletarCampos'),
      advertencia: this._t.get('msg.advertencia'),
      seguimientoGuardadoExitosamente: this._t.get('msg.seguimientoGuardadoExitosamente'),
      confirmarReabrirActividad: this._t.get('msg.confirmarReabrirActividad'),
      guardarSeguimiento: this._t.get('common.guardarSeguimiento'),
      finalizarActividad: this._t.get('common.finalizarActividad'),
    }));
  }

  getActividadInfo() {
    this._lps.show(true);
    this._sa.getActividadSolicitudInfo(this.actividadId).subscribe({
      next: (data: IGetActividadSolicitudInfo) => {
        this._lps.hide();
        if (!data) return;
        this.solicitudInfo = data;
        this.selectedUsuarioIdValido = data.usuarioAsignadoId;
      }
    });
  }

  configureForm() {
    this.seguimientoForm = this._fb.group({
      comentario: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(500)]]
    });
  }

  resetForm() {
    this.seguimientoForm.reset();
    if (this.fileUpload) {
      this.fileUpload.clear();
    }
  }

  onSubmitSeguimiento(event: Event) {
    if (this.seguimientoForm.invalid) {
      Utils.markAllFormControlsAsTouched(this.seguimientoForm);
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.advertenciaCompletarCampos });
      return;
    }

    const seguimiento = {
      comentario: this.seguimientoForm.get('comentario')?.value
    } as SeguimientoDTO
    this.createSeguimiento(seguimiento);
    this.fileUpload.clear();
  }

  finalizarActividad() {
    this._lps.show(true);  
        
    let seguimiento: SeguimientoDTO | undefined = undefined;
    if (!this.seguimientoForm.invalid) {
      seguimiento = {
        comentario: this.seguimientoForm.get('comentario')?.value
      } as SeguimientoDTO      
    }else{
      this.fileUpload.clear();
    }

    this._sa.finalizarActividad(this.actividadId, seguimiento, this.fileUpload.files).subscribe({
      next: (siguienteActividad: number) => {
        this._lps.hide();
        if (siguienteActividad === -1) {
          this._router.navigate(['/configuracion/mis-pqrsd']);
        } else {
          this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this._router.navigate(['/configuracion/pqrsd-actividad/', this.solicitudId, siguienteActividad]);
          });
        }

      }
    });
  }

  downloadFormFile(saveFile: boolean) {
    this._lps.show(true);
    this._as.downloadFormFile(this.solicitudInfo.solicitudId).subscribe({
      next: (response: Blob) => {
        this._lps.hide();
        if (response.size > 0) {
          if (saveFile)
            saveAs(response, this.solicitudInfo.documentoNombre);
          else
            this.visorDialog.showDialog(response);
        }
      }
    });
  }

  createSeguimiento(seguimiento: SeguimientoDTO) {
    this._lps.show(true);
    this._ss.createSeguimiento(this.actividadId, seguimiento, this.fileUpload.files).subscribe({
      next: (response: boolean) => {
        this.seguimientoForm.reset();
        this._ms.add({ severity: 'success', summary: 'Exito', detail: this.trans.seguimientoGuardadoExitosamente });
        this._lps.hide();
      }
    });
  }

  //#region Reasignar Actividad
  getUsuariosValidosParaActividad() {
    this._sa.getUsuariosValidosParaActividad(this.actividadId).subscribe({
      next: (usuarios: IGetUsuariosValidos[]) => {
        this.usuariosValidos = usuarios;
      }
    });
  }

  onUsuarioValidoChange(event: DropdownChangeEvent) {
    this._cs.confirm({
      header: "Reasignar Actividad",
      target: event.originalEvent.target as EventTarget,
      message: 'Estas seguro de que quieres reasignar la actividad?',
      accept: () => {
        this.reasignarActividad(event.value);
      },
      reject: () => {
        this.selectedUsuarioIdValido = this.solicitudInfo.usuarioAsignadoId;
      }
    });
  }

  reasignarActividad(usuarioId: number) {
    this._lps.show(true);
    this._sa.reasignarActividad(this.actividadId, usuarioId).subscribe({
      next: (response: string) => {
        this._ms.add({ severity: 'success', summary: this.trans.exito, detail: response });
        this.getActividadInfo();
        this._lps.hide();
      }
    });
  }
  //#endregion Reasignar Actividad

  //#region Rechazar
  private configureRechazarForm() {
    this.rechazarForm = this._fb.group({
      observaciones: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(255)]],
    });
  }

  resetRechazarForm() {
    this.rechazarForm.reset();
  }

  openRechazarModal() {
    this.resetRechazarForm();
    this.displayRechazarModal = true;
  }

  private rechazarSolicitud(observaciones: string) {
    this._lps.show(true);
    this._s.rechazarSolicitud(this.solicitudId, observaciones).subscribe({
      next: (response: string) => {
        this._ms.add({ severity: 'success', summary: this.trans.exito, detail: "Solicitud fue rechazada." });
        this.displayRechazarModal = false;
        this._lps.hide();
        this._router.navigate(['/configuracion/mis-pqrsd']);
      }
    });
  }

  onSubmitRechazarForm() {
    if (this.rechazarForm.invalid) {
      Utils.markAllFormControlsAsTouched(this.rechazarForm);
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.advertenciaCompletarCampos });
      return;
    }

    this.rechazarSolicitud(this.rechazarForm.get('observaciones')?.value);
  }
  //#endregion Rechazar

  //#region Reabrir

  reabrirActividadConfirm(event: MouseEvent) {
    this._cs.confirm({
      target: event.target as EventTarget,
      header: this.trans.reabrirActividad,
      message: this.trans.confirmarReabrirActividad,
      accept: () => {
        this.reabrirActividad();
      },
      reject: () => {

      }
    });
  }

  reabrirActividad() {
    this._lps.show(true);
    this._sa.reabrirActividad(this.actividadId).subscribe({
      next: (response: string) => {
        this._ms.add({ severity: 'success', summary: this.trans.exito, detail: response });
        this.getActividadInfo();
        this._lps.hide();
      }
    });
  }
  //#endregion Reabrir
}
